import { ref, onBeforeUnmount, getCurrentInstance } from 'vue';

/**
 * Get the current theme-aware text color.
 * Returns a ref with the appropriate color based on the current data-theme attribute.
 * Uses a MutationObserver to track DOM attribute changes.
 */
export function useThemeColor() {
  const getColorForTheme = () => {
    const theme = document.documentElement.getAttribute('data-theme');
    return theme === 'light' ? '#1a0c22' : '#f2eaf6';
  };

  const textColor = ref<string>(getColorForTheme());

  // Watch for theme attribute changes
  const observer = new MutationObserver(() => {
    textColor.value = getColorForTheme();
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-theme'],
  });

  // Only register cleanup if we're in a component context
  if (getCurrentInstance()) {
    onBeforeUnmount(() => {
      observer.disconnect();
    });
  }

  return textColor;
}
